import styled, { css } from 'styled-components';
import { reworkCalendarDayHighlighted, reworkCalendarDayHover, reworkCalendarDayNumber, reworkCalendarDayNumberHighlighted, reworkCalendarDayNumberHover, reworkCalendarDayPrice, reworkCalendarDayPriceHighlighted, reworkCalendarDayPriceHover, } from '@widgets/shared/components/CustomDatepicker/components/DatepickerDay/styles/rework';
import { reworkCalendarDay } from '@widgets/shared/components/CustomDatepicker/styles/rework';
import { dayWrapper } from '@widgets/shared/components/CustomDatepicker/components/DatepickerDay/styles/default';
export const Price = styled.span ``;
export const Number = styled.span ``;
export const Wrapper = styled.div `
  ${dayWrapper}
  
  ${({ lowAvailability, selected, }) => css `
    ${reworkCalendarDay}
    
    ${Number} {
      ${reworkCalendarDayNumber}

      ${lowAvailability && css `
        color: #F3921E !important;
      `}
    }
    
    ${Price}{
      ${reworkCalendarDayPrice}

      ${css `
        @media screen and (max-width: 320px) {
          font-size: 1rem;
          line-height: 1.2rem;
        }
      `}
    }
    
    &:hover {
      ${reworkCalendarDayHover}
      
      ${Number} {
        ${reworkCalendarDayNumberHover}
      }
      
      ${Price} {
        ${reworkCalendarDayPriceHover}
      }
    }
    
    ${selected && css `
      ${reworkCalendarDayHighlighted}
      
      ${Number} {
        ${reworkCalendarDayNumberHighlighted}
      }
      
      ${Price} {
        ${reworkCalendarDayPriceHighlighted}
      }
    `}
  `}
`;
export default {
    Wrapper,
};
